




































import { Component, Vue } from 'vue-property-decorator';
import mapSettings from '@/settings/MapSettings';
import {
    mapOptionsOn,
    mapOptionsOff,
    mapOptionsNoControl,
    mapOptionsBlackNoControl,
    mapOptionsOnRetailer2
} from '@/settings/MapOptions';
import { MapSetting, Marker, InfoWindow, Coordinate } from '@/models/Retailer';
import { websiteText } from '@/mixins/websiteTexts';

declare var google: any;

@Component
export default class RetailerMap2 extends Vue {
    $refs!: {
        googleMap: any;
    };

    protected settings!: MapSetting;
    protected options: any;
    protected mapMarkers: Marker[] = [];
    protected mapMarkersDelay: Marker[] = [];

    protected isInteractive: boolean = false;
    protected isDarkTheme: boolean = false;
    protected hideInfoWindow: boolean = false;

    protected singleMarker: boolean = false;

    protected markerCoords: Coordinate = { lat: 0, lng: 0 };
    protected mapMarkerUrl: string;
    protected infoWindow: InfoWindow;

    constructor() {
        super();

        this.settings = mapSettings;
        this.options = mapOptionsOnRetailer2;
        this.mapMarkerUrl = '/ui/assets/marker3.svg';

        this.infoWindow = {
            position: { lat: 0, lng: 0 },
            open: false,
            template: ''
        } as InfoWindow;

        this.isInteractive = this.$attrs['isInteractive'] === 'True' ? true : false;
        this.isDarkTheme = this.$attrs['dark-theme'] === 'True' ? true : false;
        this.hideInfoWindow = this.$attrs['hide-info'] === 'True' ? true : false;
        this.mapMarkers = this.getMapMarkers();
    }

    mounted() {
        if (this.mapMarkers) {
            // this.setMarker();
            this.setFitBounds();
            this.addMarkersDelay();
        }
        if (!this.isInteractive) {
            this.options = mapOptionsOnRetailer2;
            if (this.isDarkTheme) {
                this.options = mapOptionsBlackNoControl;
                this.mapMarkerUrl = '/ui/assets/marker3-white.svg';
            }
        }
    }

    private setFitBounds() {
        this.$refs.googleMap.$mapPromise.then((map: any) => {
            if (this.singleMarker) {
                map.setZoom(15);
                this.centerMarker(this.mapMarkers[0].position);
            } else {
                const bounds = new google.maps.LatLngBounds();
                this.mapMarkers.forEach((marker: Marker) => {
                    bounds.extend(new google.maps.LatLng(marker.position.lat, marker.position.lng));
                });
                map.fitBounds(bounds);
            }
        });
    }

    private centerMarker(coordinate: Coordinate) {
        this.$refs.googleMap.$mapPromise.then((map: any) => {
            map.setCenter(coordinate);
            const mapElem = document.getElementById('map'); // On small devices place marker at bottom
            if (mapElem && mapElem.clientWidth < 900) {
                const mapHeight = mapElem.clientHeight;
                const offSetFromBottom = 80;
                map.panBy(0, -(mapHeight / 2 - offSetFromBottom));
            }
        });
    }

    private addMarkersDelay() {
        if (this.mapMarkers.length > 0) {
            this.infoWindow.open = false; // Hide open infowindow after new search
            this.mapMarkersDelay = []; // Reset markers
            this.addDelayMarker();
        }
    }

    private addDelayMarker() {
        const dropAnimationTime = this.mapMarkers.length < 10 ? 1200 : 2000;
        const groupSize = this.mapMarkers.length < 10 ? this.mapMarkers.length : 10;
        const groups = this._.chunk(this.mapMarkers, this.mapMarkers.length / groupSize);
        const delay = dropAnimationTime / groups.length;

        for (let index = 0; index < groups.length; index++) {
            const group = groups[index];
            this.addMarkerWithTimeoutGroup(group, delay * index);
        }
    }

    private addMarkerWithTimeoutGroup(markers: Marker[], timeout: number) {
        setTimeout(() => {
            this.mapMarkersDelay = this._.concat(this.mapMarkersDelay, markers);
        }, timeout);
    }

    private toggleInfoWindow(m: Marker, index: number) {
        if (this.singleMarker) {
            return;
        }
        this.infoWindow.open = true;
        this.infoWindow.template = `<div class="map-infowindow-inner"><div class="map-infowindow-heading">${
            m.city
        }</div><div class="map-infowindow-content"><div class="retailer-name">${m.name}</div><a href="${
            m.url
        }" target="${
            m.target
        }" class="cta-button map-infowindow-link" data-action="gaet" data-gaet="{&quot;hitType&quot;:&quot;event&quot;,&quot;category&quot;:&quot;Outbound Links&quot;,&quot;action&quot;:&quot;Retailer Web Link&quot;,&quot;label&quot;:&quot;Ballingslöv | Stockholm City&quot;,&quot;value&quot;:null}" target="_blank">${websiteText(
            'retailer.moreinfo'
        )}</a></div></div>`;
        this.infoWindow.position = {
            lat: m.position.lat,
            lng: m.position.lng
        };
        this.mapMarkers.map(marker => {
            marker.selected = false;
        });
        this.mapMarkers[index].selected = true;
        // this.settings.zoom = 14;

        if (this.mapMarkers[index].position) {
            // this.centerMarker(this.mapMarkers[index].position);
        }

        const test = websiteText('product.colors');
    }

    private getMapMarkers(): Marker[] {
        let markers: Marker[] = [];

        if (this.$attrs.markers) {
            markers = (JSON.parse(this.$attrs.markers) as unknown) as Marker[];
          //  console.log('getMarkers', markers);
        }

        return markers;
    }
}
